module.exports = __webpack_public_path__ + "static/media/download_white.237d495d.svg";